
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-5 h-5",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_43_817)"}},[_c('path',{attrs:{"d":"M17.5 0.5H2.5C1.12083 0.5 0 1.62083 0 3V18C0 19.3783 1.12083 20.5 2.5 20.5H17.5C18.8783 20.5 20 19.3783 20 18V3C20 1.62083 18.8783 0.5 17.5 0.5Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.75 10.5V8C13.75 7.31 14.31 7.375 15 7.375H16.25V4.25H13.75C11.6783 4.25 10 5.92833 10 8V10.5H7.5V13.625H10V20.5H13.75V13.625H15.625L16.875 10.5H13.75Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_43_817"}},[_c('rect',{attrs:{"width":"20","height":"20","fill":"white","transform":"translate(0 0.5)"}})])])])
          )
        }
      }
    